export function fmt(value: unknown, column?: string): string {
  if (value === null || value === undefined || value === '') return '-';

  if (typeof value === 'number') {
    if (Number.isNaN(value)) return '-';

    if (column && /(率|占比|达成率|毛利率|执行率|活跃率|闭环率|频次达成率|达标率|环比|同比)/.test(column)) {
      return `${(value * 100).toFixed(1)}%`;
    }

    if (Math.abs(value) >= 1000) {
      return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  return String(value);
}

export function kpiColor(label: string): string {
  if (/高|风险|断档|不达标|低成交|未执行|老货龄|异常|预警|状态/.test(label)) return 'red';
  if (/中|关注/.test(label)) return 'orange';
  if (/绿|健康|达成|成交|活跃|达标|库存/.test(label)) return 'green';
  if (/三一|车铺|校园|终端|人数|门店|网点/.test(label)) return 'purple';
  return 'blue';
}

export function healthClass(value: string, column: string): string {
  if (column === '库存健康') {
    if (value === '预警') return 'red';
    if (value === '高库存') return 'orange';
    if (value === '健康') return 'green';
    if (value === '低库存') return 'orange';
    if (value === '无库存') return 'blue';
  }

  if (column === '健康度') {
    if (value === '异常') return 'red';
    if (value === '关注') return 'orange';
    if (value === '健康') return 'green';
  }

  if (column === '状态') {
    if (value === '异常' || value === '未执行' || value === '高风险') return 'red';
    if (value === '正常' || value === '健康' || value === '达标') return 'green';
    if (value === '关注') return 'orange';
  }

  if (/预警$/.test(column)) {
    if (value === '红灯' || value === '异常') return 'red';
    if (value === '黄灯' || value === '关注') return 'orange';
    if (value === '绿灯' || value === '正常' || value === '健康') return 'green';
  }

  if (column === '风险等级') {
    if (/🔴|高风险/.test(value)) return 'red';
    if (/🟡|中风险/.test(value)) return 'orange';
    if (/🟢|低风险/.test(value)) return 'green';
  }

  if (column === '低成交率执行人') {
    return value === '重点关注' ? 'red' : 'green';
  }

  return '';
}

export function isTotalRow(row: Record<string, unknown>): boolean {
  return Object.values(row).some((v) => {
    if (typeof v !== 'string') return false;
    return v === '总计' || v === '汇总' || v === '合计' || v === 'Total';
  });
}

/** 把 filters 对象格式化为可读的筛选状态文本 */
export function formatFilters(filters: Record<string, string | undefined> | undefined): string {
  if (!filters) return '全部';
  const parts: string[] = [];
  for (const [key, value] of Object.entries(filters)) {
    if (!value) continue;
    const tokens = value.split(/\s+/).filter(Boolean);
    if (tokens.length === 0) continue;
    if (tokens.length === 1) {
      parts.push(`${key}=${tokens[0]}`);
    } else {
      parts.push(`${key}∈[${tokens.join('、')}]`);
    }
  }
  return parts.length > 0 ? parts.join('；') : '全部';
}

/** 统计已生效的筛选字段数 */
export function activeFilterCount(filters: Record<string, string | undefined> | undefined): number {
  if (!filters) return 0;
  let count = 0;
  for (const value of Object.values(filters)) {
    if (value && value.trim().length > 0) count++;
  }
  return count;
}
